import Swiper, { Lazy, Autoplay, Pagination } from 'swiper'
Swiper.use([Lazy, Autoplay, Pagination])

import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus'

for (let sliderElement of document.querySelectorAll('.wpce-slider-integrated')) {
  let swiper = new Swiper(
    `#${sliderElement.dataset.swiperId}`,
    JSON.parse(sliderElement.dataset.options),
  )

  // Keyboard focus is not handled by Swiper.js itself
  swiperHandleKeyboardFocus(swiper)
}
